import { message } from "antd";
import { Dispatch, SetStateAction } from "react";
import { useSelectOptions } from "../../../../hooks/search";
import { SelectOption } from "../../../../types/select";

type UseLeasesSearchOptions = {
  selectedSearchBy: string;
  setSelectedSearchBy: Dispatch<SetStateAction<string>>;
  setSearchValue: Dispatch<SetStateAction<string>>;
};

export const useLeasesSearch = (options: UseLeasesSearchOptions) => {
  const { selectedSearchBy, setSelectedSearchBy, setSearchValue } = options;

  const { selectOptions } = useSelectOptions({ selectedSearchBy });

  function handleSearch(value: string) {
    const length = value?.length ?? 0;

    if (length === 0) {
      setSearchValue("");
      return;
    }

    // if (selectedSearchBy !== "mobileNumber" && length < 2) {
    //   message.error("Please enter at least two characters");
    //   return;
    // }

    if (selectedSearchBy === "mobileNumber" && length < 3) {
      message.error("Please enter at least three characters");
      return;
    }

    setSearchValue(value);
  }

  function handleChangeSearchBy(option: SelectOption) {
    setSelectedSearchBy(String(option?.value));
    setSearchValue("");
  }

  return { selectOptions, handleSearch, handleChangeSearchBy };
};
